import { LabelSettingProps } from '../../../global/models/epi-model';
import { AddressFields } from '../models/form-models';

export const getAddressLabels = (labelSettings: LabelSettingProps): AddressFields => {

    return {
        country: labelSettings.countryLabel,
        address1: labelSettings.addressLabel1,
        address2: labelSettings.addressLabel2,
        address3: labelSettings.addressLabel3,
        city: labelSettings.cityLabel,
        state: labelSettings.stateLabel,
        province: labelSettings.provinceLabel,
        postalCode: labelSettings.postalLabel,
    };
};